export enum WebReportMobileAssetCategory {
  Lift = 1,
  Slope = 2,
  Trail = 3,
  Gastro = 4,
  Poi = 5,
  Meteo = 6,
}
